/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectBYOAppsRequest {
  /**
  * Customer\'s Azure tenant ID where apps are registered
  */
  'customerTenantId': string;
  /**
  * Application ID of the Data Access App (on customer tenant)
  */
  'dataAccessAppId': string;
  /**
  * Service Principal ID of Data Access App on customer tenant
  */
  'dataAccessServicePrincipalId': string;
  /**
  * Key Vault secret URL containing Data Access App\'s client secret. This is the versionless URL from the customer\'s Key Vault. 
  */
  'dataAccessAppSecretUrl': string;
  /**
  * Application ID of the Management App (on customer tenant)
  */
  'managementAppId': string;
  /**
  * Service Principal ID of Management App on customer tenant
  */
  'managementServicePrincipalId': string;
  /**
  * Key Vault secret URL containing Management App\'s client secret. This is the versionless URL from the customer\'s Key Vault. 
  */
  'managementAppSecretUrl': string;
  /**
  * Service Principal ID of the KV Access App on customer\'s tenant. The customer creates a Service Principal for EON\'s KV Access App in their tenant. 
  */
  'kvAccessAppServicePrincipalId': string;
  /**
  * Resource ID of the MI on customer tenant for restore operations. Used for federated credential auth when restore VM is on customer tenant. 
  */
  'dataAccessFederatedMiResourceId': string;
  /**
  * Optional. Application ID of the Agent App on customer tenant. Required if the customer has an EON agent running in their environment. 
  */
  'agentAppId'?: string;
  /**
  * Optional. Service Principal ID of the Agent App on customer tenant. Required if agentAppId is provided. 
  */
  'agentServicePrincipalId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "customerTenantId",
      "baseName": "customerTenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "dataAccessAppId",
      "baseName": "dataAccessAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "dataAccessServicePrincipalId",
      "baseName": "dataAccessServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "dataAccessAppSecretUrl",
      "baseName": "dataAccessAppSecretUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementAppId",
      "baseName": "managementAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "managementServicePrincipalId",
      "baseName": "managementServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "managementAppSecretUrl",
      "baseName": "managementAppSecretUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "kvAccessAppServicePrincipalId",
      "baseName": "kvAccessAppServicePrincipalId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "dataAccessFederatedMiResourceId",
      "baseName": "dataAccessFederatedMiResourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "agentAppId",
      "baseName": "agentAppId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "agentServicePrincipalId",
      "baseName": "agentServicePrincipalId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return ConnectBYOAppsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

